/**
 * Address Finder Constants
 * Configuration constants for the address lookup functionality
 */

// UI State Constants
export const UI_STATES = {
  IDLE: 'idle',
  SEARCHING: 'searching',
  RESULTS: 'results',
  SELECTED: 'selected',
  ERROR: 'error',
  MANUAL: 'manual'
};

// Search Configuration
export const SEARCH_CONFIG = {
  MIN_POSTCODE_LENGTH: 5,
  MAX_POSTCODE_LENGTH: 8,
  MIN_QUERY_LENGTH: 2,
  DEFAULT_LIMIT: 10,
  MAX_LIMIT: 25,
  DEBOUNCE_DELAY: 300 // milliseconds
};

// UI Configuration
export const UI_CONFIG = {
  MAX_VISIBLE_RESULTS: 10,
  RESULT_ITEM_HEIGHT: 60,
  SEARCH_INPUT_DELAY: 500,
  AUTO_COMPLETE_THRESHOLD: 3
};

// Error Messages
export const ERROR_MESSAGES = {
  INVALID_POSTCODE: 'Please enter a valid UK postcode (e.g., SW1A 1AA)',
  POSTCODE_REQUIRED: 'Postcode is required for address lookup',
  QUERY_TOO_SHORT: `Search query must be at least ${SEARCH_CONFIG.MIN_QUERY_LENGTH} characters`,
  NO_RESULTS: 'No addresses found for this postcode',
  NETWORK_ERROR: 'Unable to connect to address lookup service',
  SERVICE_UNAVAILABLE: 'Address lookup service is currently unavailable',
  RATE_LIMITED: 'Too many requests. Please wait a moment and try again',
  GENERIC_ERROR: 'An error occurred while searching for addresses'
};

// Success Messages
export const SUCCESS_MESSAGES = {
  ADDRESS_SELECTED: 'Address selected successfully',
  ADDRESS_UPDATED: 'Address updated successfully'
};

// Validation Patterns
export const VALIDATION = {
  UK_POSTCODE: /^[A-Z]{1,2}\d[A-Z\d]?\s?\d[A-Z]{2}$/i,
  UPRN: /^\d{1,12}$/
};

// Address Field Mapping
export const ADDRESS_FIELDS = {
  LINE1: 'address_line1',
  LINE2: 'address_line2',
  CITY: 'address_city',
  COUNTY: 'address_county',
  POSTCODE: 'address_postcode',
  COUNTRY: 'address_country',
  UPRN: 'address_uprn',
  LEGACY: 'address' // For backward compatibility
};

// Default Values
export const DEFAULTS = {
  COUNTRY: 'United Kingdom',
  LIMIT: SEARCH_CONFIG.DEFAULT_LIMIT,
  PLACEHOLDER_POSTCODE: 'Enter postcode (e.g., SW1A 1AA)',
  PLACEHOLDER_QUERY: 'Enter building name or number (optional)'
};

// CSS Classes (if using CSS modules or styled components)
export const CSS_CLASSES = {
  CONTAINER: 'address-finder',
  SEARCH_CONTAINER: 'address-finder__search',
  INPUT: 'address-finder__input',
  BUTTON: 'address-finder__button',
  RESULTS_CONTAINER: 'address-finder__results',
  RESULT_ITEM: 'address-finder__result-item',
  RESULT_SELECTED: 'address-finder__result-item--selected',
  ERROR: 'address-finder__error',
  LOADING: 'address-finder__loading',
  MANUAL_FORM: 'address-finder__manual-form'
};

// API Response Status
export const API_STATUS = {
  SUCCESS: 'success',
  ERROR: 'error'
};

// Component Props Defaults
export const PROP_DEFAULTS = {
  SHOW_MANUAL_ENTRY: true,
  SHOW_VALIDATION: true,
  AUTO_SELECT_SINGLE: true,
  CLEAR_ON_SELECT: false,
  PLACEHOLDER: DEFAULTS.PLACEHOLDER_POSTCODE
};

export default {
  UI_STATES,
  SEARCH_CONFIG,
  UI_CONFIG,
  ERROR_MESSAGES,
  SUCCESS_MESSAGES,
  VALIDATION,
  ADDRESS_FIELDS,
  DEFAULTS,
  CSS_CLASSES,
  API_STATUS,
  PROP_DEFAULTS
};